import { render, staticRenderFns } from "./agreement-consent.vue?vue&type=template&id=144215b2&scoped=true&"
import script from "./agreement-consent.vue?vue&type=script&lang=js&"
export * from "./agreement-consent.vue?vue&type=script&lang=js&"
import style0 from "./agreement-consent.vue?vue&type=style&index=0&id=144215b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144215b2",
  null
  
)

export default component.exports